import type { CertificateFields, CertificateSampleData } from "@/components/certificates/CertificatePreview";

export interface CertificateMetaRow {
  label: string;
  value: string;
}

function splitParticipantName(fullName: string): { firstName: string; lastName: string } {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
    return { firstName: "", lastName: "" };
  }

  const [firstName, ...rest] = parts;
  return {
    firstName,
    lastName: rest.join(" "),
  };
}

export function getCertificateParticipantDisplayName(
  sampleData: CertificateSampleData,
  fields: CertificateFields,
): string {
  const participantParts = splitParticipantName(sampleData.participantName);
  const nameParts = [
    fields.showParticipantName ? participantParts.firstName : "",
    fields.showParticipantLastName ? participantParts.lastName : "",
  ]
    .filter(Boolean)
    .join(" ")
    .trim();

  return nameParts || sampleData.participantName.trim();
}

export function getCertificateMetaRows({
  fields,
  sampleData,
  workloadHours,
}: {
  fields: CertificateFields;
  sampleData: CertificateSampleData;
  workloadHours?: number | null;
}): CertificateMetaRow[] {
  const rows: CertificateMetaRow[] = [];

  if (fields.showEventDate && sampleData.eventDate) {
    rows.push({ label: "Data", value: sampleData.eventDate });
  }

  if (fields.showEventTime && sampleData.eventTime) {
    rows.push({ label: "Hora", value: sampleData.eventTime });
  }

  if (fields.showEventLocation && sampleData.eventLocation) {
    rows.push({ label: "Local", value: sampleData.eventLocation });
  }

  if (fields.showWorkload && workloadHours != null) {
    rows.push({ label: "Carga horária", value: `${workloadHours} horas` });
  }

  return rows;
}
